// extracted by mini-css-extract-plugin
export var avatar = "recipe-author-module--avatar--c0680";
export var black = "recipe-author-module--black--ceb61";
export var dot = "recipe-author-module--dot--b2e1f";
export var wrapper = "recipe-author-module--wrapper--9cdc6";